import React, { Component } from 'react';
import './App.css';
import FilterButton from './FilterButton';
import Grid from './Grid';
import Tray from './Tray';
import Background from './Background';
import Header from './Header';
import Overlay from './Overlay';
import ScreenshotGrid from './ScreenshotGrid';
import logosData from './data/logos.json';
import screenshotsData from './data/screenshots.json';
//import ContactForm from './ContactForm';
import oddBanner from './images/odd_banner_2024.png';
import Content from './Content';
import twirly from './images/twirly.svg'



var defaultFilterIds = ["googlecloud","google","vmware","kp_org"];

    let item0cp = { 
                gf: ["googlecloud","google","vmware","kp_org","intel","docker","redbox","redboxinstant","gigable","optus","farmers","kp","backtrace","mashery","smartinsure"],
                colorStyle: "ltredBorder",
                selectedStyle: "ltredFill",
                label: "All"
              }

              let item1cp = { 
                gf: ["googlecloud","google","vmware","kp_org"],
                colorStyle: "ltredBorder",
                selectedStyle: "ltredFill",
                label: "Most Recent"
              }

    let item2cp = { 
                gf: ["intel","docker","redbox","redboxinstant","gigable","kp"],
                colorStyle: "ltyellowBorder",
                selectedStyle: "yellowFill",
                label: "Leadership"
              }


    let item3cp = { 
                gf: ["googlecloud","vmware","intel","docker","mashery","gigable"],
                colorStyle: "ltyellowBorder",
                selectedStyle: "yellowFill",
                label: "Innovation"
              }
   
    let item4cp = { 
                gf: ["backtrace","docker","gigable","mashery"],
                colorStyle: "ltcyanBorder",
                selectedStyle: "ltcyanFill",
                label: "Startup"
              }
    let item5cp = { 
                gf: ["google","vmware","intel","farmers","docker"],
                colorStyle: "ltcyanBorder",
                selectedStyle: "ltcyanFill",
                label: "Enterprise"
              }
    let item6cp = { 
                gf: ["optus","redbox","redboxinstant","kp","gigable"],
                colorStyle: "ltcyanBorder",
                selectedStyle: "ltcyanFill",
                label: "Consumer"
              }
    let item7cp = { 
                gf: ["mashery","docker","backtrace","googlecloud"],
                colorStyle: "ltcyanBorder",
                selectedStyle: "ltcyanFill",
                label: "Developer"
              }
   
    let item8cp = { 
                gf: ["docker","gigable","ExxonMobil"],
                colorStyle: "ltcyanBorder",
                selectedStyle: "ltcyanFill",
                label: "Brand & Identity"
              }

const filterbuttonArray = []
var currentSSArray = []
var masterViewArray=[]
//setup current screenshot array and displayed index here

class App extends Component {
    constructor(props) {
      super(props);
      this.state = { 
        show: true, 
        gridfilter: defaultFilterIds,
        showGrid: false,
        showTray: false,
        showCover: true,
        showHeader: false,
        showFilters: false,
        showContactForm: false,
        showScreenshotGrid: false,
        showContent:false,
        updateProjectState: false,
        mobile: false,
        showOverlay:false,
        imgObj:null,
        currentview:[null],
        showContact:false,
        viewElementsArray:["header","filters","logogrid","cover","tray","screenshotgrid","contactform"]
      }
      this.ProjectState = {name:"start",JSON:screenshotsData['start']}
      this.handleFilterClick = this.handleFilterClick.bind(this)
      this.updateProject = this.updateProject.bind(this)
      this.registerFilterButton = this.registerFilterButton.bind(this)
      this.updateSelectedFilter = this.updateSelectedFilter.bind(this)
      this.navigateTo = this.navigateTo.bind(this)
      this.updateOverlay = this.updateOverlay.bind(this)
      this.updateView = this.updateView.bind(this)
      this.displayOverlay=this.displayOverlay.bind(this)
      this.setCurrentSSArray=this.setCurrentSSArray.bind(this)
      this.closePage=this.closePage.bind(this)
      this.handleContactClose=this.handleContactClose.bind(this)
      //initiate view
      masterViewArray=["header","filters","cover"]

    }

    set projectState(fprojectState){
         this.projectState = fprojectState
         
    }

    setCurrentSSArray(fSSarray){
        currentSSArray = fSSarray
        console.log("array is"+ JSON.stringify(currentSSArray[5]))
    }

    get projectState(){
      return this.projectState
    }

  componentWillUpdate(){
    console.log("about to render App")
  }

    updateProject (val) {
        this.ProjectState = {name:val,JSON:screenshotsData[val]}
        this.setState({updateProjectState:true,showScreenshotGrid:true},this.reportProjectUpdate())
        
    }

    reportProjectUpdate (){
        console.log("project state name " + this.ProjectState.name)
        //console.log("project state json " + JSON.stringify(this.ProjectState.JSON))
    }


    registerFilterButton(instance){
      //console.log("registered")
      filterbuttonArray.push(instance)
      instance.setState({selected:false})
    }

    handleFilterClick(val) {
      this.setState({gridfilter: val})
      var newArray=["header","filters","cover","logogrid"]
      this.updateView(newArray) 
    }

    updateOverlay(fimgObj,displaystate,isfirstopen) {
      if(isfirstopen){
      console.log("firstopen: update overlay on app was called")
      var newArray=["header","filters","logogrid"]
      this.updateView(newArray) 
      this.setState({showOverlay:true,imgObj:fimgObj})
    } else {
      console.log("nextopen: update overlay on app was called")
      this.setState({showOverlay:true,imgObj:fimgObj})
    }
    }

    displayOverlay(fstate) {
      if (fstate) {
      var newArray=["overlay"]
      this.updateView(newArray) 
      this.setState({showOverlay:fstate})
    } else {
      this.setState({showOverlay:fstate})
      var newArray2=["header","filters","logogrid","screenshotgrid"]
      this.updateView(newArray2) 
    }
    }

   handleContactClose () {
    this.setState({showContact:false})
   }

    updateView(fviewArray) {
      //loop through view elements and set visibility based on switch
      console.log("view should be updated"+fviewArray)
      masterViewArray=[]
      masterViewArray=fviewArray

        this.state.viewElementsArray.forEach((page, index) => {

          switch (page) {
            case "header":
            if (masterViewArray.includes(page)) {
              this.setState({showHeader:true})
              console.log("show:"+page)
            } else {
              this.setState({showHeader:false})
            }
            break
            case "filters":
            if (masterViewArray.includes(page)) {
              console.log("show:"+page)
              this.setState({showFilters:true})
            } else {
              this.setState({showFilters:false})
            }
            break
            case "logogrid":
            if (masterViewArray.includes(page)) {
              console.log("show:"+page)
              this.setState({showGrid:true})
            } else {
              this.setState({showGrid:false})
            }
            break
            case "cover":
            if (masterViewArray.includes(page)) {
              console.log("show:"+page)
              this.setState({showCover:true})
            } else {
              this.setState({showCover:false})
            }
            break
            case "tray":
            if (masterViewArray.includes(page)) {
              console.log("show:"+page)
              this.setState({showTray:true})
            } else {
              this.setState({showTray:false})
            }
            break
            case "screenshotgrid":
            if (masterViewArray.includes(page)) {
              console.log("show:"+page)
              this.setState({showScreenshotGrid:true})
            } else {
              this.setState({showScreenshotGrid:false})
            }
            break
            case "contactform":
            if (masterViewArray.includes(page)) {
              console.log("show:"+page)
              this.setState({showContactForm:true})
            } else {
              this.setState({showContactForm:false})
            }
            break
            case "content":
            if (masterViewArray.includes(page)) {
              console.log("show:"+page)
              this.setState({showContent:true})
            } else {
              this.setState({showContent:false})
            }
            break
            case "overlay":
            if (masterViewArray.includes(page)) {
              console.log("show:"+page)
              this.setState({showOverlay:true})
            } else {
              this.setState({showOverlay:false})
            }
            break

            default:
            console.log("default case for some reason")
            break
          }
          }
      )
    }

  


    navigateTo(page){
      //console.log("navigation was clicked")
      switch(page) {
        case "home":
          var newArray=["header","filters","cover"]
           this.clearAllSelectedFilters()
          this.updateView(newArray)   
        break
        case "engage":
          this.setState({showTray: true,showScreenshotGrid:false})
        break

      case "contact":
      console.log("open contact form")
        this.setState({showContact: true})
      break
        default:
        break
      }
    }

    closePage(){
      this.setState({showTray: false})
    }

    clearAllSelectedFilters(){
      filterbuttonArray.forEach((ins,index) => {
        ins.setState({selected:false})
      })

    }

    updateSelectedFilter(instance){
      //console.log("updated selected filter")
      this.grid.resetAllSelectedItems()
      filterbuttonArray.forEach((ins,index) => {
        if(ins!==instance){
          ins.setState({selected:false})
          } else {
            instance.setState({selected:true})
          }
      })
    }

  render() {


    return (

      <div className="pageContainer">
         <Background />
         <Header trayCB={this.navigateTo} />
         <Overlay ref={overlay => { this.overlay = overlay}} updateCB={this.updateOverlay} ssArray={currentSSArray} overlayCB={this.displayOverlay} appImgObj={this.state.imgObj} projectState={this.ProjectState.name} overlayState={this.state.showOverlay} />
         <div className="headerPlaceholder"></div>
         {/*
         <div className={this.state.showContact ? 'contact show' : 'contact hide' }>

         <div className="contactWrapper">
         <p className="bold">Send a note</p>
         <div onClick={this.handleContactClose} className="closeButton"></div>
         <br/>
            <ContactForm />
            </div>

         </div>
         */}
   
        <div className="mainContainer">
            <div className="oddContent">
                <div className="filterContainer">
                        <FilterButton updateSelected={this.updateSelectedFilter} reg={this.registerFilterButton} action={() => this.handleFilterClick(item0cp.gf)} buttonProps={item0cp} />
                        <FilterButton updateSelected={this.updateSelectedFilter} reg={this.registerFilterButton} action={() => this.handleFilterClick(item1cp.gf)} buttonProps={item1cp} />
                        <FilterButton updateSelected={this.updateSelectedFilter} reg={this.registerFilterButton} action={() => this.handleFilterClick(item2cp.gf)} buttonProps={item2cp}  />
                        <FilterButton updateSelected={this.updateSelectedFilter} reg={this.registerFilterButton} action={() => this.handleFilterClick(item3cp.gf)} buttonProps={item3cp}  />
                        <FilterButton updateSelected={this.updateSelectedFilter} reg={this.registerFilterButton} action={() => this.handleFilterClick(item4cp.gf)} buttonProps={item4cp} />
                        <FilterButton updateSelected={this.updateSelectedFilter} reg={this.registerFilterButton} action={() => this.handleFilterClick(item5cp.gf)} buttonProps={item5cp} />
                        <FilterButton updateSelected={this.updateSelectedFilter} reg={this.registerFilterButton} action={() => this.handleFilterClick(item6cp.gf)} buttonProps={item6cp}  />
                        <FilterButton updateSelected={this.updateSelectedFilter} reg={this.registerFilterButton} action={() => this.handleFilterClick(item7cp.gf)} buttonProps={item7cp}  />
                        <FilterButton updateSelected={this.updateSelectedFilter} reg={this.registerFilterButton} action={() => this.handleFilterClick(item8cp.gf)} buttonProps={item8cp}  />
                             
                </div>
                <div className="gridContainer" style={{visibility: this.state.showGrid ? 'visible' : 'hidden' }}>
                        <Grid ref={grid => { this.grid = grid}}  updateView={this.updateView} updateProject={this.updateProject} project={this.ProjectState.name} name="logoGrid" gridfilter={this.state.gridfilter} JSON={logosData}/>
                </div>
                <div className="coverContent" style={{display: this.state.showCover ? 'flex' : 'none' }}><p className="huge">Ah … instinct, let’s not forget how important you are. We must test you, instinct, reconcile you with our experience and color you with enticing hues!</p>
                <img alt="Small Twirly Graphic" className="twirly" src={twirly} /></div>
            </div>
              <div className="screenshotgridContainer" style={{display: this.state.showScreenshotGrid ? 'flex' : 'none' }}>
              <ScreenshotGrid setSSContextCB={this.setCurrentSSArray} controllerCB={this.updateOverlay} updateProjectState={this.state.updateProjectState} name="screenshotGrid" project={this.ProjectState.name} JSON={this.ProjectState.JSON} />
            </div>
              
            
              <div className="trayContainer" style={{display: this.state.showTray ? 'flex' : 'none' }}>
                  <Tray appCB={this.closePage} context="notmobile"/>
              </div>
              <div className="contentContainer" style={{display: this.state.showContent ? 'flex' : 'none' }}>
              <Content />
              </div>
              <img className="oddBanner" src={oddBanner} alt="odd banner" height="367" width="702" />
              {/* <div className="trayContainerMobile" style={{visibility: this.state.mobile ? 'visible' : 'hidden' }}>
                <Tray context="mobile"/>
              </div>   
              */}
            </div>
       </div>
    )
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js